<!-- Renders trusted playbook HTML from `linkify()`; see the SECURITY note in `linkify.ts`. -->
<script lang="ts">
	const { html }: { html: string } = $props();
</script>

<span class="linkified">{@html html}</span>

<style>
	/* `:global` because the markup comes from `{@html}`; the `.linkified` prefix keeps it scoped. */
	.linkified :global {
		.footnoteRef {
			margin: 0 var(--space-1);
			color: var(--text-muted);
			font-weight: var(--weight-bold);
		}

		.bibLink {
			cursor: pointer;
			margin: 0 var(--space-1);
			border: none;
			background: none;
			padding: 0;
			color: var(--link-color);
			font: inherit;
			text-decoration: underline;
		}

		.bibPopover {
			box-shadow: var(--shadow-lg);
			border: 1px solid var(--border-color);
			border-radius: var(--radius);
			padding: var(--space-3) var(--space-5) var(--space-5);
			width: min(960px, 100vw - 2rem);

			&::backdrop {
				backdrop-filter: blur(3px);
				background: var(--backdrop);
			}

			ul {
				padding-left: var(--space-3);
				list-style: none;
			}

			li {
				margin: var(--space-4) 0;
			}
		}

		.bibClose {
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			margin-left: auto;
			border: none;
			border-radius: var(--radius);
			background: none;
			padding: 0;
			min-width: var(--target-min);
			min-height: var(--target-min);
			color: var(--text-color);

			&:hover {
				background-color: var(--hover-surface);
			}
		}
	}
</style>
